import { useState, useEffect } from 'react';
import { Network } from '@capacitor/network';
import { isNative } from '@/lib/platform';

export function useNetworkStatus() {
  const [isOnline, setIsOnline] = useState(true);

  useEffect(() => {
    if (isNative) {
      Network.getStatus().then(s => setIsOnline(s.connected));
      const sub = Network.addListener('networkStatusChange', s => setIsOnline(s.connected));
      return () => { sub.then(l => l.remove()); };
    } else {
      setIsOnline(navigator.onLine);
      const onOnline = () => setIsOnline(true);
      const onOffline = () => setIsOnline(false);
      window.addEventListener('online', onOnline);
      window.addEventListener('offline', onOffline);
      return () => {
        window.removeEventListener('online', onOnline);
        window.removeEventListener('offline', onOffline);
      };
    }
  }, []);

  return isOnline;
}
